import React, { useState, useEffect } from 'react';
import {
  Burger,
  NavLink,
  ScrollArea,
  Text,
  ThemeIcon,
  Drawer,
  useMantineTheme,
  Menu,
  Center,
  Stack,
  Avatar,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import useStyles from './DashboardLayout.styles';
import {  IconLogout, IconSettings, } from '@tabler/icons-react';
import { navLinks } from '../Navlinks/navLinks';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../store/slices/authSlice';

function DashboardLayout() {
  const { classes } = useStyles();
  const [sidebarOpened, setSidebarOpened] = useState(true);
  // Store open state for any submenu by parent label
  const [openSubmenus, setOpenSubmenus] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const sidebarWidth = 250;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const theme = useMantineTheme();

  // Adjust sidebar open state based on screen size
  useEffect(() => {
    setSidebarOpened(!isMobile);
  }, [isMobile]);

  // Close all submenus if the sidebar is closed
  useEffect(() => {
    if (!sidebarOpened) {
      setOpenSubmenus({});
    }
  }, [sidebarOpened]);

  const handleLogout = () => {
    dispatch(clearUser());
    setOpenSubmenus({});
    navigate('/login');
  };

  // Toggle submenu open state for a given label
  const toggleSubmenu = (label) => {
    setOpenSubmenus((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  // Recursive function to render navigation items
  const renderNavLinks = (links) =>
    links.map((link) => {
      if (link.children) {
        // Determine active state if any child route is active
        const isActive = link.children.some((child) => location.pathname === child.to);
        return (
          <NavLink
            key={link.label}
            label={link.label}
            icon={link.icon}
            active={isActive}
            opened={openSubmenus[link.label] || false}
            onClick={() => toggleSubmenu(link.label)}
            fw={600}
            mb={5}
          >
            {renderNavLinks(link.children)}
          </NavLink>
        );
      } else {
        return (
          <NavLink
            key={link.label}
            component={Link}
            to={link.to}
            label={link.label}
            icon={link.icon}
            active={location.pathname === link.to}
            fw={600}
            mb={5}
          />
        );
      }
    });

  const sidebarContent = (
    <ScrollArea className={classes.scrollArea}>
      <div className={classes.sidebarHeader}>
        {/* <ThemeIcon size="xl" variant='light' radius={50}>
          <IconUser style={{ width: '70%', height: '70%' }} />
        </ThemeIcon> */}
        <Avatar radius="xl" size="lg" color="cyan">
          {user.username
            .split('@')[0]
            .substring(0, 2)
            .toUpperCase()}
        </Avatar>
        <Text size="md" fw={600}>{user.username
          .split('@')[0]
          .split('.')[0]
          .replace(/^./, (c) => c.toUpperCase())}</Text>
      </div>
      {renderNavLinks(navLinks)}
    </ScrollArea>
  );
  return (
    <div className={classes.container}>
      {isMobile ? (
        <Drawer
          opened={sidebarOpened}
          onClose={() => setSidebarOpened(false)}
          size="sm"
          padding="md"
          withCloseButton={false}
          title={null}
          overlayProps={{ opacity: 0.5, blur: 2 }}
        >
          {sidebarContent}
        </Drawer>
      ) : (
        <div className={classes.sidebar} style={{ width: sidebarOpened ? sidebarWidth : 0 }}>
          {sidebarContent}
        </div>
      )}
      <div className={classes.header} style={{ left: !isMobile && sidebarOpened ? sidebarWidth : 0, right: 0 }}>
        <Burger
          opened={sidebarOpened}
          onClick={() => setSidebarOpened((prev) => !prev)}
          size="sm"
          color='white'
        />
        <div style={{ display: 'flex' }}>
          <Text weight={500} size="lg" mr={50} style={{ color: theme.colors.cyan[9] }}>
            {user.username}
          </Text>
          {/* <ActionIcon variant="transparent" onClick={handleLogout}>
            <ThemeIcon size="lg" variant='light'>
              <IconLogout style={{ width: '70%', height: '70%' }} />
            </ThemeIcon>
          </ActionIcon> */}
          <Menu shadow="md" width={200} position="bottom-end" withArrow transitionProps={{ transition: 'slide-up', duration: 300 }} >
            <Menu.Target>
              <ThemeIcon size="lg" variant='light'>
                <IconLogout style={{ width: '70%', height: '70%' }} />
              </ThemeIcon>
            </Menu.Target>
            <Menu.Dropdown >
              {/* Centered User Info */}
              <Center py="lg">
                <Stack spacing={4} align="center">
                  <Avatar radius="xl" size="lg" color="cyan">
                    {user.username
                      .split('@')[0]
                      .substring(0, 2)
                      .toUpperCase()}
                  </Avatar>
                  <Text size="md" fw={600}>{user.username
                    .split('@')[0]
                    .split('.')[0]
                    .replace(/^./, (c) => c.toUpperCase())}</Text>
                </Stack>
              </Center>
              {/* Settings Item */}
              <Menu.Item icon={<IconSettings size={16} />}>
                Settings
              </Menu.Item>
              <Menu.Divider />
              <Menu.Label>Danger zone</Menu.Label>
              {/* Logout Item */}
              <Menu.Item
                color="red"
                icon={<IconLogout size={16} />}
                onClick={handleLogout}
              >
                Log Out
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      </div>
      <div
        className={classes.content}
        style={{ marginLeft: !isMobile && sidebarOpened ? sidebarWidth : 0 }}
      >
        <Outlet />
      </div>
    </div>
  );
}

export default DashboardLayout;
